import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultFiltersWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    position: relative;
    overflow: hidden;
`;

export const ScrollableFiltersContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding: 2px 0;
    
    /* Hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;
    
    &::-webkit-scrollbar {
        display: none;
    }
    
    /* Prevent wrapping on smaller screens */
    @media (max-width: 768px) {
        flex-wrap: nowrap;
    }
    
    /* Allow wrapping on larger screens */
    @media (min-width: 769px) {
        flex-wrap: wrap;
        overflow-x: visible;
    }
`;

export const ScrollArrow = styled.button`
    display: none;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${colors.gray3};
    background: white;
    color: ${colors.darkGray1};
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    z-index: 1;
    
    &:hover {
        border-color: ${colors.darkGray1};
        background: ${colors.gray1};
    }
    
    &:active {
        transform: scale(0.95);
    }
    
    /* Show arrows only on smaller screens */
    @media (max-width: 768px) {
        display: flex;
    }
    
    ${props => props.direction === 'left' && `
        margin-right: 4px;
    `}
    
    ${props => props.direction === 'right' && `
        margin-left: 4px;
    `}
`;

export const VaultFilterButton = styled.div`
   display: flex;
    height: 40px;
    padding: 0px 14px;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    white-space: nowrap;

    border-radius: 20px;
    border: 1px solid ${colors.gray3};

    color: ${colors.darkGray1};
    font-family: Circular;
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 1.265;

    &:hover {
        ${({ isActive }) => isActive ? `
            background: ${colors.darkGray1};
            opacity: 0.9;
        ` : `
            border: 1px solid ${colors.darkGray1};
        `} 
    }

    ${props => props.isActive && `
        background: ${colors.darkGray1};
        border-color: ${colors.darkGray1};
        color: #fff;
    `}
`;

export const CloseButton = styled.div`
    display: flex;
    width: 16px;
    height: 16px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.2);
    transition: background 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
    }

    svg {
        width: 12px;
        height: 12px;
    }
`;

export const FilterIconWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;



